import { createAction } from 'redux-actions'

const ns = 'upload/'

export const resetUploadedFileDto = createAction(`${ns}RESET_UPLOADED_FILE_URL`)

export const uploadImage = createAction(`${ns}UPLOAD_IMAGE`)
export const uploadImageSuccess = createAction(`${ns}UPLOAD_IMAGE_SUCCESS`)
export const uploadImageFail = createAction(`${ns}UPLOAD_IMAGE_FAIL`)

export const deleteFile = createAction(`${ns}DELETE_FILE`)
